var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM15.5498 6.04492C15.2058 5.73916 14.6788 5.77027 14.373 6.11426L8.29297 12.9531L5.58496 10.2451L5.50684 10.1758C5.17993 9.92159 4.70665 9.94471 4.40625 10.2451C4.08099 10.5705 4.08094 11.0984 4.40625 11.4238L7.74023 14.7568L7.81543 14.8242C8.15666 15.0919 8.65634 15.0543 8.95215 14.7217L15.6191 7.22168L15.6836 7.13867C15.9178 6.7975 15.867 6.3271 15.5498 6.04492Z",
    fill: "#00AD3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilled);
export default __webpack_public_path__ + "static/media/checkCircleFilled.8385817e6388e7b823965c8023f644e6.svg";
export { ForwardRef as ReactComponent };